import { createBrowserHistory } from 'history';
import { useLocation } from 'react-router-dom';
//export const history = createBrowserHistory();
// TODO: find out if this is the best place to set the base path
const WINDOW_BASE_PATH_KEY = '__prophecy_window_base_path';
const globalState = window;
export const history = createBrowserHistory({
    window
});
export function getBasePath() {
    return globalState[WINDOW_BASE_PATH_KEY] || process.env.PUBLIC_URL || '';
}
/**
 * react-router@v6's history module doesn't support basename
 * https://github.com/remix-run/history/issues/811#issue-648979053
 *
 * functions historyPush/historyReplace can be in place of history.push/history.replace
 */
export function historyPush(to, state) {
    return history.push(getBasePath() + to, state);
}
export function historyReplace(to, state) {
    const url = to.startsWith(getBasePath()) ? to : getBasePath() + to;
    return history.replace(url, state);
}
export const useLocationPathName = () => {
    const location = useLocation();
    return location.pathname.replace(getBasePath(), '');
};
/**
 * Remove a single query param from the current URL without adding a history
 * entry or triggering a navigation. Uses history.replace (a replaceState under
 * the hood), so every other query param and the hash are preserved and no
 * re-render/reload is triggered. No-op if the param is absent.
 */
export function removeQueryParam(param) {
    const params = new URLSearchParams(window.location.search);
    if (!params.has(param)) {
        return;
    }
    params.delete(param);
    const search = params.toString();
    history.replace({
        // pathname already includes the base path, so don't re-prepend it here
        pathname: window.location.pathname,
        search: search ? `?${search}` : '',
        hash: window.location.hash
    });
}
export function navigateAndRefresh(to) {
    window.location.href = getBasePath() + to;
}
export function openInNewWindow(to) {
    window.open(getBasePath() + to);
}
export function clearStorage() {
    if (window.location.hostname !== 'localhost') {
        localStorage.clear();
        sessionStorage.clear();
    }
}
export function setBasePath(basePath) {
    globalState[WINDOW_BASE_PATH_KEY] = basePath;
}
export function resetBasePath() {
    globalState[WINDOW_BASE_PATH_KEY] = process.env.PUBLIC_URL || '';
}
